import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Dashboard from './pages/Dashboard';
import DiagnosticTest from './pages/DiagnosticTest';
import MaleTypeIdentifier from './pages/MaleTypeIdentifier';
import MessageLibrary from './pages/MessageLibrary';
import EmergencyProtocol from './pages/EmergencyProtocol';
import Calendar from './pages/Calendar';
import Consolidation from './pages/Consolidation';
import SuccessStories from './pages/SuccessStories';
import PersonalGrowth from './pages/PersonalGrowth';
import Community from './pages/Community';
export function App() {
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <Router data-id="element-1">
        <Navigation data-id="element-2" />
        <main className="container mx-auto px-4 py-8" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Dashboard data-id="element-6" />} data-id="element-5" />
            <Route path="/diagnostic-test" element={<DiagnosticTest data-id="element-8" />} data-id="element-7" />
            <Route path="/male-type" element={<MaleTypeIdentifier data-id="element-10" />} data-id="element-9" />
            <Route path="/messages" element={<MessageLibrary data-id="element-12" />} data-id="element-11" />
            <Route path="/emergency" element={<EmergencyProtocol data-id="element-14" />} data-id="element-13" />
            <Route path="/calendar" element={<Calendar data-id="element-16" />} data-id="element-15" />
            <Route path="/consolidation" element={<Consolidation data-id="element-18" />} data-id="element-17" />
            <Route path="/success-stories" element={<SuccessStories data-id="element-20" />} data-id="element-19" />
            <Route path="/personal-growth" element={<PersonalGrowth data-id="element-22" />} data-id="element-21" />
            <Route path="/community" element={<Community data-id="element-24" />} data-id="element-23" />
          </Routes>
        </main>
      </Router>
    </div>;
}